import React, { useGlobal, useState, useEffect } from "reactn";
import { withRouter } from "react-router-dom";
import PageLayout from "../../../components/page-layout/page-layout.component";
import useSWR from "swr";
import LoaderPane from "../../../components/loader-pane/loader-pane.component";

import { Row, Col, Table } from "react-bootstrap";
import PaginationBar from "../../../components/pagination-bar/pagination-bar.component";
import ComplaintModal from "../../../components/modal/complaint-modal/complaint-modal.component";
import useAccessLevels from "../../../hooks/useAccessLevels";

const AdminComplaintsPage = (props) => {
  const [currentUser, setCurrentUser] = useGlobal("currentUser");
  const [state, setState] = useState({
    activeTab: 0,
    query: "",
    status: "",
    loading: true,
    openModal: false,
    activeBook: null,
    activeOrder: null,
    openOrderModal: false,
  });

  const [paginate, setPaginate] = useState({
    page: 0, // index 0, add +1
    pageSize: 20,
  });

  const { data, error, mutate, isValdating } = useSWR(
    `complaint?query=${state?.query}&offset=${
      paginate.page * paginate.pageSize
    }&limit=${paginate.pageSize}`
  );

  const { hasAccess } = useAccessLevels(currentUser?.user?.accessLevels);
  const access = hasAccess("Complaints");
  const [complaintModal, setComplaintModal] = useState({
    open: false,
    complaint: null,
  });

  return (
    <div>
      <ComplaintModal
        open={complaintModal.open}
        complaint={complaintModal?.complaint}
        currentUser={currentUser}
        onHide={() => setComplaintModal({ open: false, complaint: null })}
        onUpdated={() => {
          mutate();
        }}
        access={access}
      />
      <PageLayout
        activeLink="complaints"
        parentMenu="complaints"
        inputProps={{
          value: state.query,
          onChange: (e) => {
            setState({ ...state, query: e.target.value });
          },
        }}
      >
        <div className="mt-3">
          <div className="text-24 mb-20">Complaints</div>

          <div>
            <LoaderPane
              loading={isValdating || (!data && !error)}
              noRecords={!isValdating && data?.complaints?.length === 0}
              error={error?.message}
            />

            {data && (
              <div>
                <Table>
                  <thead>
                    <tr>
                      <th>Email</th>
                      <th>Description</th>
                      <th>Note</th>
                      <th>Response</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.complaints?.map((s, i) => (
                      <tr key={i}>
                        <td>
                          {s?.user?.username}
                          <div className="text-12">
                            {new Date(s.createdAt).toDateString()}
                          </div>
                        </td>

                        <td>{s.description}</td>
                        <td>{s.note}</td>
                        <td>{s.response}</td>
                        <td>
                          <span
                            className={` ${
                              s.status?.toLowerCase() == "pending"
                                ? "bg-primary"
                                : "bg-success"
                            } text-12  p-1 rounded text-white`}
                          >
                            {s.status}
                          </span>
                        </td>
                        <td>
                          <span
                            className="text-danger font-500 pointer"
                            onClick={() => {
                              setComplaintModal({
                                complaint: { ...s },
                                open: true,
                              });
                            }}
                          >
                            View
                          </span>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={8}>
                        <PaginationBar
                          page={paginate.page}
                          pageSize={paginate.pageSize}
                          totalItems={
                            data?.complaints?.length >= paginate.pageSize
                              ? paginate.pageSize * (paginate.page + 2)
                              : paginate.pageSize * (paginate.page + 1)
                          }
                          onChangePage={(newPage) => {
                            setPaginate({
                              ...paginate,
                              page: newPage,
                            });
                          }}
                          onChangeRowsPerPage={(size) => {
                            setPaginate({
                              pageSize: size,
                              page: 0,
                            });
                          }}
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            )}
          </div>
        </div>
      </PageLayout>
    </div>
  );
};

export default withRouter(AdminComplaintsPage);
